import React from 'react';

const SupportIconMenu = ({ ...rest }) => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_5301_1596)">
        <g opacity="0.2">
          <path d="M23 11C16.9346 11 12 15.9346 12 22V26.5573C12 27.6837 12.9867 28.6 14.2 28.6H15.3C15.5917 28.6 15.8715 28.4841 16.0778 28.2778C16.2841 28.0715 16.4 27.7917 16.4 27.5V21.8427C16.4 21.551 16.2841 21.2712 16.0778 21.0649C15.8715 20.8586 15.5917 20.7427 15.3 20.7427H14.3012C14.9128 16.4857 18.5758 13.2 23 13.2C27.4242 13.2 31.0872 16.4857 31.6988 20.7427H30.7C30.4083 20.7427 30.1285 20.8586 29.9222 21.0649C29.7159 21.2712 29.6 21.551 29.6 21.8427V28.6C29.6 29.8133 28.6133 30.8 27.4 30.8H25.2V29.7H20.8V33H27.4C29.8266 33 31.8 31.0266 31.8 28.6C33.0133 28.6 34 27.6837 34 26.5573V22C34 15.9346 29.0654 11 23 11Z" fill="currentColor"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5301_1596">
          <rect width="44" height="44" rx="12" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SupportIconMenu;